import { cn } from '@/lib/utils'
import { AppSidebar } from './AppSidebar'
import { TopBar } from './TopBar'

export interface AppLayoutProps {
  /** Page content */
  children: React.ReactNode
  /** Additional CSS classes for the main content area */
  className?: string
}

/**
 * Root application layout: fixed sidebar + top bar + scrollable main area.
 * Replaces the old PageShell top-nav layout.
 *
 * ```
 * ┌───────┬──────────────────────────────────┐
 * │       │  TopBar (breadcrumbs, user)       │
 * │ Side  ├──────────────────────────────────┤
 * │ bar   │                                  │
 * │       │  Main content (scrollable)        │
 * │       │                                  │
 * └───────┴──────────────────────────────────┘
 * ```
 */
export function AppLayout({ children, className }: AppLayoutProps) {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar */}
      <AppSidebar />

      {/* Main area */}
      <div className="flex flex-1 flex-col min-w-0">
        <TopBar />
        <main className={cn('flex-1 min-h-0 overflow-y-auto', className)}>
          {children}
        </main>
      </div>
    </div>
  )
}
